export default "__VITE_ASSET__CtdrDE9g__"